import { modelVoices } from "@/utils/tools";
import React, { useEffect, useState } from "react";
import AudioPlayer3 from "./AudioPlayer3";
import { FaPause, FaPlay } from "react-icons/fa";
import { useAudioPlayer } from "./GlobalAudioPlayer";
import Image from "next/image";
import VoiceImage from "./VoiceImage";
import { useQuery } from "react-query";
import axios from "axios";

const TryVoiceSection = ({ modelData }) => {
  const voices = modelVoices;
  const [sortedVoices, setSortedVoices] = useState([]);
  const getGenderFromVoice = (voice) => {
    return voice.name.toLowerCase().includes("female") ? "female" : "male";
  };

  const [playing, setPlaying] = useState(null);

  useEffect(() => {
    if (modelData && voices) {
      const modelGender = modelData?.tts?.gender;

      // Attach an index to each voice for secondary sorting
      const voicesWithIndex = voices.map((voice, index) => ({
        ...voice,
        index,
      }));

      // Sort voices based on the model's gender, with secondary sorting by original index
      const sorted = [...voicesWithIndex].sort((a, b) => {
        let aGender = getGenderFromVoice(a);
        let bGender = getGenderFromVoice(b);

        if (aGender === bGender) {
          // If genders are the same, sort by original index
          return a.index - b.index;
        } else if (modelGender === "female") {
          // Prioritize female voices if model is female
          return aGender === "female" ? -1 : 1;
        } else {
          // Prioritize male voices if model is male
          return aGender === "male" ? -1 : 1;
        }
      });

      setSortedVoices(sorted);
    }
  }, [modelData, voices]);

  const hasSuccessfulDemo = modelData?.demos?.some(
    (d) => d?.status !== "failed",
  );

  if (!hasSuccessfulDemo) {
    return null;
  }
  const { playAudio, info, pauseAudio, isPlaying } = useAudioPlayer();

  // const conversion = modelData.models[0];

  return (
    <div className="tw-w-full">
      <div className="tw-font-bold tw-flex tw-text-xl">Try Voice</div>
      <div className="tw-font-semibold tw-mt-1 tw-opacity-40 tw-text-sm">
        Demos are auto-generated to show the quality of voices.
      </div>
      <div className="tw-grid tw-grid-cols-2 md:tw-grid-cols-2 tw-gap-2 md:tw-gap-2 tw-mt-3">
        {sortedVoices?.map((demo) => {
          const isDemo = modelData?.demos?.find((d) => d?.name === demo?.param);

          return isDemo?.status === "failed" ? null : (
            <div
              key={demo?.name}
              className="tw-w-full tw-bg-gray-100 tw-flex tw-items-center tw-rounded-2xl  tw-p-3 tw-gap-2"
            >
              <div
                onClick={() => {
                  if (
                    isPlaying &&
                    info?.id === `${modelData?._id}-${demo?.name}`
                  ) {
                    pauseAudio();
                  } else {
                    playAudio({
                      audio: isDemo?.convertedUrl,
                      info: {
                        image: modelData?.image?.url,
                        name: demo?.name,
                        id: `${modelData?._id}-${demo?.name}`,
                        artistNames: modelData?.artistname,
                      },
                    });
                  }
                }}
                className="tw-bg-white tw-p-3 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-sm tw-text-purple-700 tw-cursor-pointer"
              >
                {isPlaying && info?.id === `${modelData?._id}-${demo?.name}` ? (
                  <FaPause />
                ) : (
                  <FaPlay />
                )}
              </div>
              <div>
                <div className="tw-font-bold">{demo?.name}</div>
                <div className="tw-text-xs  tw-text-black/40 tw-italic">
                  English
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TryVoiceSection;
